import {
  ERROR_ACTION, GET_ADD_DEPARTMENT_LIST, GET_USER_LISTING, GET_USER_LISTING_COUNTER, SET_DEPARTMENT_TABLE_COUNTER, SET_UNAPPROVED_USER_LIST, GET_ADD_ROLE_LIST, SET_ROLE_TABLE_COUNTER, GET_USER_BY_SUPERVISIOR
} from "../../common/constants/ActionTypes";


const initialState = {
  departmentTableCounter: 0,
  getdepartmentList: [],
  roleTableCounter: 0,
  roleList: [],
};

export default function accessRightsManagementReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
      case GET_ADD_DEPARTMENT_LIST:
        return {
          ...state,
          departmentList: action.payload,
        };
        case SET_DEPARTMENT_TABLE_COUNTER:
        return{
          ...state,
          departmentTableCounter:action.payload
        };
        case GET_USER_LISTING:
          return{
            ...state,
            userListing:action.payload
          };
          case SET_UNAPPROVED_USER_LIST:
            return{...state,
              unapprovedUser_list:action.payload
            };
            case GET_USER_LISTING_COUNTER:
              return{
               ...state,
               approvalUserListing:action.payload
              };
              case GET_ADD_ROLE_LIST:
      return {
        ...state,
        roleList: action.payload,
      };
    case SET_ROLE_TABLE_COUNTER:
      return {
        ...state,
        roleTableCounter: action.payload
      }
    case GET_USER_LISTING:
      return {
        ...state,
        userListing: action.payload
      }
    case SET_UNAPPROVED_USER_LIST:
      return {
        ...state,
        unapprovedUser_list: action.payload
      }
    case GET_USER_LISTING_COUNTER:
      return {
        ...state,
        approvalUserListing: action.payload
      }
      case GET_USER_BY_SUPERVISIOR:
        return{
          ...state,
          getUser:action.payload
        }
    default:
      return state;
  }
}
